
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.445 5.425c0 .167.112.28.28.28h5.42c.168 0 .28-.113.28-.28 0-.168-.112-.28-.28-.28H9.25V2.463C9.307 1.457 8.468.619 7.463.619a1.86 1.86 0 00-1.845 1.844v2.682h-.894a.28.28 0 00-.279.28zm3.018-3.912c.53 0 .95.42.95.922 0 .53-.42.95-.95.95-.531 0-.95-.42-.95-.95 0-.503.419-.922.95-.922z","fill":"#A44CD3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.866 4.195h3.24c.671 0 1.202.531 1.202 1.202v13.02c0 .671-.53 1.202-1.201 1.202H1.818c-.67 0-1.201-.531-1.201-1.202V5.397c0-.67.53-1.202 1.201-1.202H5.06v.391h-.336a.823.823 0 00-.838.839c0 .475.363.838.838.838h5.477a.823.823 0 00.838-.838.823.823 0 00-.838-.839h-.335v-.39zM8.674 10.51a1.704 1.704 0 10-2.41-2.41 1.704 1.704 0 002.41 2.41zm.856 1.088l-1.145-.391a.508.508 0 00-.615.223l-.307.447-.308-.475c-.14-.195-.39-.307-.614-.223l-1.174.419c-.699.307-1.174.978-1.174 1.76v.475c0 .168.14.28.28.28h5.98a.28.28 0 00.279-.28v-.475c0-.754-.475-1.453-1.202-1.76zm-7.318 4.405a.3.3 0 01.3-.3h10.09a.3.3 0 110 .6H2.512a.3.3 0 01-.3-.3zm0 1.49a.3.3 0 01.3-.3h6.07a.3.3 0 010 .6h-6.07a.3.3 0 01-.3-.3z","fill":"#A44CD3"}}),_c('path',{attrs:{"fill":"#A44CD3","d":"M1.82 18.138h11.23V6.908H1.82z"}}),_c('path',{attrs:{"d":"M7.463 7.828L2.938 9.19v4.645c0 3.038 4.525 4.302 4.525 4.302s4.524-1.264 4.524-4.304V9.189L7.463 7.828zm-.92 7.093L4.852 13.23l.615-.616 1.078 1.078 2.915-2.917.615.615-3.532 3.53z","fill":"#00263E"}})])
          )
        }
      }
    